module.exports = __webpack_public_path__ + "static/media/brands_FRANKLIN.17f5b43a.svg";